import {
  SET_ANALYTICS_DATA,
  SET_USAGE_METRICS_DATA,
  ISetAnalyticsDataAction,
  ISetUsageMetricsDataAction,
  IAnalyticsDataItem,
  IUsageMetricsDataItem,
} from './types';
import { prepareReadCommandAction } from '../crud/actions';
import { WsCommandSubject } from '../crud/types';

export const setAnalyticsDataAction = (data: IAnalyticsDataItem[]): ISetAnalyticsDataAction => ({
  type: SET_ANALYTICS_DATA,
  payload: data,
});

export const setUsageMetricsDataAction = (data: IUsageMetricsDataItem[]): ISetUsageMetricsDataAction => ({
  type: SET_USAGE_METRICS_DATA,
  payload: data,
});

export const prepareReadUsageMetricsCommandAction = () =>
  prepareReadCommandAction({
    type: 'analytics' as WsCommandSubject,
    params: {
      subType: 'usage-metrics',
    },
  });
